import { commonService } from '.';

const getProfile = (body) => {
    return commonService.getWithParam('User/profile', body);
};

const getUserDc = (body) => {
    return commonService.getWithParam('User/userDc', body);
};

const updateLang = (body) => {
    return commonService.putWithParam('User/updateLang', body);
};

const getUserAccount = () => {
    return commonService.getWithParam('User/userAccount', null)
}

const getUserInfos = (idUser) => {
    return commonService.getWithParam('User/infos?idUser=' + idUser, null)
}

const hasManagerPermission = (idUserData, page) => {
    return commonService.getWithParam('User/hasManagerPermission?idUserData=' + idUserData + '&page=' + page, null);
}

export const userService = {
    getProfile,
    getUserDc,
    updateLang,
    getUserAccount,
    getUserInfos,
    hasManagerPermission
};
